import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBase } from 'src/app/_models/form-base';

@Component({
    selector: 'app-radio-button',
    templateUrl: './radio-button.component.html',
    styleUrls: ['./radio-button.component.scss'],
    imports: [FormsModule, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadioButtonComponent {
  /** Field form base for radio button group (required) */
  field = input<FormBase<string>>();

  /** Parent FormGroup containing the control (required) */
  parentForm = input<FormGroup>();

  /** The currently selected value (when loading existing data) */
  currentValue = input<string | undefined>(undefined);

  /** Is the input disabled? (optional) */
  isDisabled = input<boolean | undefined>(undefined);

  /** The size of the radio button group (optional) */
  size = input<'small' | 'large'>('large');

  /** Emitted when the radio selection changes */
  radioButtonChange = output<string>();

  updateValue(event: Event): void {
    const v = (event.target as HTMLInputElement).value;
    this.radioButtonChange.emit(v);
  }
}
